import { apiBaseUrl, apiService } from './api';

// Modèles 3D et jumeaux numériques des documents d'un projet (routes /projects/:id/models).
const base = (projectId) => `/projects/${projectId}/models`;

const raw = async (path) => {
  const token = localStorage.getItem('auth_token');
  const response = await fetch(`${apiBaseUrl}${path}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!response.ok) {
    let detail = '';
    try { detail = (await response.json()).detail; } catch (error) { /* corps vide */ }
    throw new Error(detail || 'Fichier indisponible.');
  }
  return response;
};

export const saveResponse = async (response, fallback) => {
  const disposition = response.headers.get('Content-Disposition') || '';
  const match = /filename\*=UTF-8''([^;]+)/.exec(disposition);
  const url = URL.createObjectURL(await response.blob());
  const link = Object.assign(document.createElement('a'), { href: url, download: match ? decodeURIComponent(match[1]) : fallback });
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const modelsApi = {
  list: (projectId) => apiService.get(base(projectId)),
  get: (projectId, modelId) => apiService.get(`${base(projectId)}/${modelId}`),
  upload: (projectId, file, { title, unit, modelId, label } = {}, onProgress) => {
    const form = new FormData();
    form.append('file', file);
    if (title) form.append('title', title);
    if (label) form.append('label', label);
    form.append('unit', unit || 'mm');
    return apiService.uploadFile(modelId ? `${base(projectId)}/${modelId}/versions` : base(projectId), form, onProgress);
  },
  update: (projectId, modelId, body) => apiService.patch(`${base(projectId)}/${modelId}`, body),
  label: (projectId, modelId, versionId, label) => apiService.patch(`${base(projectId)}/${modelId}/versions/${versionId}`, { label }),
  restore: (projectId, modelId, versionId) => apiService.post(`${base(projectId)}/${modelId}/versions/${versionId}/restore`, {}),
  view: async (projectId, modelId, versionId, asText = false) => {
    const response = await raw(`${base(projectId)}/${modelId}/versions/${versionId}/view`);
    return asText ? response.text() : response.arrayBuffer();
  },
  downloadSource: async (projectId, modelId, versionId, fallback) => saveResponse(
    await raw(`${base(projectId)}/${modelId}/versions/${versionId}/source`), fallback),
  comments: (projectId, modelId) => apiService.get(`${base(projectId)}/${modelId}/comments`),
  addComment: (projectId, modelId, body, versionId) => apiService.post(`${base(projectId)}/${modelId}/comments`, { body, version_id: versionId || null }),
  resolve: (projectId, modelId, commentId, reply) => apiService.post(`${base(projectId)}/${modelId}/comments/${commentId}/resolve`, { reply }),
  share: (projectId, modelId, versionId) => apiService.post(`/projects/${projectId}/portal/model-shares`, { model_id: modelId, version_id: versionId }),
  withdraw: (projectId, shareId) => apiService.delete(`/projects/${projectId}/portal/model-shares/${shareId}`),
};

// Formats lus par la visionneuse : texte pour l'OBJ et le glTF, binaire sinon.
export const textFormats = new Set(['obj', 'gltf', 'html']);
export const UNITS = [['mm', 'millimètres'], ['cm', 'centimètres'], ['m', 'mètres'], ['in', 'pouces']];
export const ACCEPT = '.step,.stp,.glb,.gltf,.stl,.obj,.html,.htm';
